import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Container from "../../../modules/commons/Container";
import MutasiPartContent from "./common/mutasiPartContent";
import { TABS } from "./config";
import { mapToObjectDDL } from "../../common/mapper";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import FlexView from "react-flexview";
import Api from "../../../Services/Api";
import { connect } from "react-redux";
import ErrorAction from "../../../Redux/ErrorRedux";

class MutasiPart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataCabang: [],
      selectedCabangData: null,
      search: { kodeCabang: null },
    };
  }

  async componentDidMount() {
    await this.fetchDataCabang();
  }

  fetchDataCabang = async () => {
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
      if (res.ok) {
        let filteredData = res.data.data.filter((item) =>
          this.props.menuAccess
            .map((data) => data.idRefObj)
            .includes(item.kodeCabang)
        );
        if (filteredData.length !== 0) {
          const firstCabang = filteredData[0];

          this.setState((prev) => ({
            ...prev,
            dataCabang: filteredData,
            search: {
              ...prev.search,
              kodeCabang: firstCabang.kodeCabang,
            },
            selectedCabangData: firstCabang,
          }));
        }
      }
    } catch (error) {
      console.log("errors", error);
    }
  };

  /**
   *
   * @param {'kodeCabang'} name
   * @param {string} value
   */
  handleSearchValueChange = (name, ddlValue) => {
    const kode = ddlValue?.value;
    const foundCabang = this.state.dataCabang.find(
      (item) => item.kodeCabang === kode
    );

    this.setState((prev) => ({
      ...prev,
      search: {
        ...prev.search,
        [name]: ddlValue,
      },
      selectedCabangData: foundCabang || null,
    }));
  };

  render() {
    return (
      <>
        <Container>
          <FlexView vAlignContent="center">
            <p
              className="margin-bottom-20px margin-right-5px"
              style={{ textAlign: "right" }}
            >
              Cabang :
            </p>
            <SimpleDDL
              id="select_options_kode_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-250px"
              placeholder="Nama Cabang"
              menuPosition="fixed"
              options={this.state.dataCabang.map((item) =>
                mapToObjectDDL(item.namaDealer, item.kodeCabang)
              )}
              value={this.state.search.kodeCabang}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Mutasi Keluar</Tab>
              <Tab>Mutasi Masuk</Tab>
            </TabList>
            <TabPanel>
              <MutasiPartContent
                user={this.props.auth.user}
                tab={TABS.mutasiKeluar}
                kodeCabang={this.state.search.kodeCabang}
                cabangData={this.state.selectedCabangData}
              />
            </TabPanel>
            <TabPanel>
              <MutasiPartContent
                user={this.props.auth.user}
                tab={TABS.mutasiMasuk}
                kodeCabang={this.state.search.kodeCabang}
                cabangData={this.state.selectedCabangData}
              />
            </TabPanel>
          </Tabs>
        </Container>
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    h1Module: state.h1Module,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MutasiPart);
